import { Button, HStack, Skeleton } from '@chakra-ui/react';
import CustomDataTableDeleteBtn from '@Modules/core/components/table/CustomDataTableDeleteBtn';
import CustomDataTableInfoBtn from '@Modules/core/components/table/CustomDataTableInfoBtn';
import { createColumnHelper } from '@tanstack/react-table';

export type TDebitApplicationValidationDataTableData = {
  primaryKey: string | number,
  applicationId: string,
  applicationDate: string,
  customer: string,
  classNb: string,
  decidedBy: string,
  decisionDate: string,
  debitProgram: string,
  cardProgram: string,
  adi: string,

  customer1: string,
  debitProgram1: string,
  agency: string,
  cardProduct: string,
  [x: string]: any,
};

type Props = {
  isLoading: boolean | undefined,
  handleDetail: (row: any) => void,
  displayDetails: (row: any) => void,
  // TODO: Add function to handle delete button event
};

const columnHelper =
  createColumnHelper<TDebitApplicationValidationDataTableData>();

export function getDebitApplicationValidationDataTableColumns({
  isLoading,
  handleDetail,
  displayDetails,
}: Props) {
  return [
    columnHelper.accessor('applicationId', {
      id: 'applicationId',
      header: 'ID App.',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('applicationDate', {
        id: 'applicationDate',
        header: 'Date App.',
        cell: (props) => {
          return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
        },
    }),
  
    columnHelper.accessor('customer', {
      id: 'customer',
      header: 'Client',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('classNb', {
        id: 'classNb',
        header: 'N° Class.',
        cell: (props) => {
          return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
        },
        enableHiding: false,
    }),
  
    columnHelper.accessor('decidedBy', {
      id: 'decidedBy',
      header: 'Decidé par',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('decisionDate', {
      id: 'decisionDate',
      header: 'Date Deci.',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('debitProgram', {
      id: 'debitProgram',
      header: 'Prog. Débit',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('cardProgram', {
      id: 'cardProgram',
      header: 'Prog. Carte',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('adi', {
      id: 'adi',
      header: 'A D I',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('customer1', {
      id: 'customer1',
      header: 'Client',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
      enableHiding: false,
    }),

    columnHelper.accessor('agency', {
      id: 'agency',
      header: 'Agence',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
      enableHiding: false,
    }),

    columnHelper.accessor('debitProgram', {
      id: 'debitProgram',
      header: 'Programme Débit',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
      enableHiding: false,
    }),
    columnHelper.accessor('cardProduct', {
      id: 'cardProduct',
      header: 'Produit Carte',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
      enableHiding: false,
    }),

    columnHelper.display({
      id: 'action',
      header: '',
      cell: (props) => {
        return (
            <HStack>
                <Skeleton isLoaded={!isLoading}>
                    <Button
                        size={'sm'}
                        onClick={() => handleDetail(props.row)}
                        mr={'1rem'}
                    >
                        Détail
                    </Button>
                </Skeleton>
                <Skeleton isLoaded={!isLoading}>
                    <CustomDataTableDeleteBtn disabled={isLoading} onClick={() => alert("are you sure you want to delete this record ?")} />
                </Skeleton>
                <Skeleton isLoaded={!isLoading}>
                    <CustomDataTableInfoBtn disabled={isLoading} onClick={() => displayDetails(props.row)} />
                </Skeleton>
            </HStack>
        );
      },
    }),
  ];
}
